export const TransactionHistoryError = () => {
  return import(
    /* webpackChunkName: "TransactionHistoryError" */ './TransactionHistoryError'
  )
}

export const TransactionDetails = () => {
  return import(
    /* webpackChunkName: "TransactionDetails" */
    '@/components/TransactionDetails/TransactionDetails'
  )
}
